import { all, call, put, takeEvery } from "redux-saga/effects";
import * as customerActions from "../slices/customerSlice";
import customerApis from "src/api/customer";
import { common } from "src/types";
import { constants } from "src/constants/common";

function* getCustomersListSaga({
  payload,
}: ReturnType<typeof customerActions.getCustomersListRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      customerApis.getCustomersList,
      payload
    );
    yield put(customerActions.getCustomersListSuccess(response));
  } catch (error) {
    yield put(
      customerActions.getCustomersListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* createCustomerSaga({
  payload,
}: ReturnType<typeof customerActions.createCustomerRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      customerApis.createCustomer,
      payload
    );
    yield put(customerActions.createCustomerSuccess(response?.data));
  } catch (error) {
    yield put(
      customerActions.createCustomerError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* editCustomerSaga({
  payload,
}: ReturnType<typeof customerActions.editCustomerRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      customerApis.updateCustomer,
      payload.id,
      payload.data
    );
    yield put(customerActions.editCustomerSuccess(response?.data));
  } catch (error) {
    yield put(
      customerActions.editCustomerError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

function* deleteCustomerSaga({
  payload,
}: ReturnType<typeof customerActions.deleteCustomerRequest>) {
  try {
    const response: common.ResponseGenerator = yield call(
      customerApis.deleteCustomer,
      payload
    );
    yield put(customerActions.deleteCustomerSuccess(response));
  } catch (error) {
    yield put(
      customerActions.deleteCustomerError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* customerSaga() {
  yield all([
    takeEvery(customerActions.getCustomersListRequest, getCustomersListSaga),
    takeEvery(customerActions.createCustomerRequest, createCustomerSaga),
    takeEvery(customerActions.editCustomerRequest, editCustomerSaga),
    takeEvery(customerActions.deleteCustomerRequest, deleteCustomerSaga),
  ]);
}
